const SvgCaretRight = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="m6.354 2.646 5 5a.5.5 0 0 1 0 .708l-5 5A.5.5 0 0 1 5.5 13V3a.5.5 0 0 1 .854-.354Z" />
  </svg>
)
export default SvgCaretRight
